import(/* webpackMode: "eager" */ "/inner-circle-tldraw/app/global-error.tsx")